module.exports = __webpack_public_path__ + "static/media/flash-card.4eb8e621.svg";